import {createReducer, on} from '@ngrx/store';
import * as NpsActions from './nps.actions';
import {NpsResponse} from 'src/app/services/widgets.service';

export interface NpsState {
    data: NpsResponse | null;
    loading: boolean;
    error: any;
    payload: any | null; // per tenere traccia dell'ultimo payload usato
}

export interface NpsStateMap {
    states: { [key: string]: NpsState } | null
}

export const initialState: NpsStateMap = {
    states: {}
};

export const npsReducer = createReducer(
    initialState,
    on(NpsActions.loadCurrentNPSSuccess, (statesMap, {data, key, payload}) => {
        return {
            ...statesMap,
            states: {
                ...statesMap.states,
                [key]: {
                    data: data,
                    loading: false,
                    error: null,
                    payload: payload
                }
            }
        };
    }),on(NpsActions.loadCurrentNPS, (statesMap, { key, payload }) => ({
        ...statesMap,
        states: {
            ...statesMap.states,
            [key]: {
                data: null,
                loading: true,
                error: null,
                payload
            }
        }
    })),
);
